/* eslint-disable angular/window-service */
import { app } from '../../bootstrap/core';
import ConfigService from './config.service';

app.service('configService', ConfigService);

export const fetchConfig = () => {
  const $http = angular.injector(['ng']).get('$http');
  return $http({
    method: 'GET',
    url: `https://tenants.fino.cloud/conf/dws/byUrl/${window.location.hostname}`,
    error: {
      silent: true,
    },
  });
};



// WEBPACK FOOTER //
// ./src/app/common/config/config.js